<div class="blackout-editor" data-testid="blackout-hours-editor">

  <p class="blackout-hint" *ngIf="timezone">
    Times below are in <strong>{{ timezone }}</strong>.
  </p>

  <div class="notification is-light" *ngIf="!ranges?.length" data-testid="blackout-no-rules">
    No non-working hours defined yet. Scoring stays available at all times until a rule is added.
  </div>

  <div
    class="blackout-rule"
    [class.is-collapsed]="!isExpanded(i)"
    *ngFor="let range of ranges; let i = index; trackBy: trackByIndex"
    [attr.data-testid]="'blackout-rule-' + i"
  >
    <div
      class="blackout-rule-head"
      [class.is-clickable]="!isExpanded(i) && !disabled"
      (click)="!isExpanded(i) && !disabled && expandRule(i)"
    >
      <div class="blackout-rule-title">
        <span class="tag" [class.is-success]="isAllowAllDay(range)" [class.is-warning]="!isAllowAllDay(range)">
          {{ isAllowAllDay(range) ? 'Available all day' : 'Non-working' }}
        </span>
        <span class="tag is-light" *ngIf="isOvernightRange(range)" [attr.data-testid]="'blackout-rule-overnight-' + i">
          overnight
        </span>
        <span class="tag is-light" *ngIf="isFullDayBlackout(range)">full day</span>
        <span class="blackout-rule-name" *ngIf="hasRuleName(range)">{{ ruleDisplayTitle(range) }}</span>
        <span class="blackout-rule-summary">{{ describeRangeSchedule(range) }}</span>
      </div>
      <div class="buttons are-small">
        <button
          *ngIf="!isExpanded(i)"
          class="button is-small is-link"
          [disabled]="disabled"
          (click)="expandRule(i, $event)"
          [attr.data-testid]="'blackout-rule-edit-' + i"
        >Edit</button>
        <button
          *ngIf="isExpanded(i)"
          class="button is-small is-primary"
          [disabled]="disabled"
          (click)="doneEditing(i, $event)"
          [attr.data-testid]="'blackout-rule-done-' + i"
        >Done</button>
        <button
          class="button is-small"
          [disabled]="disabled"
          (click)="duplicateRule(i); $event.stopPropagation()"
          [attr.data-testid]="'blackout-rule-duplicate-' + i"
        >Duplicate</button>
        <button
          class="button is-small is-danger is-outlined"
          [disabled]="disabled"
          (click)="removeRule(i); $event.stopPropagation()"
          [attr.data-testid]="'blackout-rule-remove-' + i"
        >Remove</button>
      </div>
    </div>

    <div class="blackout-rule-body" *ngIf="isExpanded(i)">

      <div class="blackout-field blackout-rule-name-field">
        <label class="label is-small" [attr.for]="'blackout-rule-' + i + '-name-input'">Rule name <span class="blackout-optional">(optional)</span></label>
        <input
          class="input is-small blackout-rule-name-input"
          type="text"
          [disabled]="disabled"
          [ngModel]="range.name || ''"
          (ngModelChange)="setRuleName(range, $event)"
          placeholder="e.g. Weeknight blackout"
          maxlength="255"
          [id]="'blackout-rule-' + i + '-name-input'"
      [attr.data-testid]="'blackout-rule-' + i + '-name'"
        />
        <p class="blackout-hint">Shown in the rule list so you can tell rules apart at a glance.</p>
      </div>

      <div class="blackout-field">
        <label class="label is-small" [id]="'blackout-rule-' + i + '-repeats-label'">Repeats on</label>
        <div class="blackout-dow" role="group" [attr.aria-labelledby]="'blackout-rule-' + i + '-repeats-label'">
          <label
            *ngFor="let dow of BLACKOUT_DOW_PROPS"
            class="checkbox"
            [attr.title]="dow.caption"
          >
            <input
              type="checkbox"
              [disabled]="disabled"
              [ngModel]="isDowChecked(range, dow.prop)"
              (ngModelChange)="setDowChecked(range, dow.prop, $event)"
              [attr.data-testid]="'blackout-rule-' + i + '-' + dow.prop"
            />
            {{ dow.short }}
          </label>
        </div>
        <div class="buttons are-small blackout-presets">
          <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset(range, 'weekdays')" [attr.data-testid]="'blackout-rule-' + i + '-preset-weekdays'">Mon–Fri</button>
          <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset(range, 'weekend')" [attr.data-testid]="'blackout-rule-' + i + '-preset-weekend'">Sat–Sun</button>
          <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset(range, 'all')" [attr.data-testid]="'blackout-rule-' + i + '-preset-all'">Every day</button>
          <button type="button" class="button is-small is-light" [disabled]="disabled" (click)="setWeekdayPreset(range, 'none')" [attr.data-testid]="'blackout-rule-' + i + '-preset-clear'">Clear</button>
        </div>
      </div>

      <div class="blackout-field blackout-dates-field">
        <ng-container *ngIf="isDateSectionOpen(range, i); else datesCollapsed">
          <label class="label is-small" [id]="'blackout-rule-' + i + '-dates-label'">Date range <span class="blackout-optional">(optional)</span></label>

          <div class="blackout-date-row" role="group" [attr.aria-labelledby]="'blackout-rule-' + i + '-dates-label'">
            <div class="blackout-date-field">
              <span class="blackout-sub-label">Start date</span>
              <blackout-date-dropdown
                [value]="range.date_start"
                [disabled]="disabled"
                [testIdPrefix]="'blackout-rule-' + i + '-date-start'"
            ariaLabel="Start date"
                (valueChange)="onDateStartChange(range, i, $event)"
              ></blackout-date-dropdown>
            </div>

            <div class="blackout-date-field">
              <span class="blackout-sub-label">End date</span>
              <blackout-date-dropdown
                [value]="range.date_end"
                [disabled]="disabled"
                [testIdPrefix]="'blackout-rule-' + i + '-date-end'"
            ariaLabel="End date"
                (valueChange)="onDateEndChange(range, i, $event)"
              ></blackout-date-dropdown>
            </div>
          </div>

          <p class="blackout-hint">
            Leave both blank for a rule that repeats every week. Set only a start date for a single day.
          </p>

          <div class="buttons are-small">
            <button
              type="button"
              class="button is-small is-light"
              [disabled]="disabled"
              *ngIf="hasDateValues(range)"
              (click)="clearDates(range, i)"
              [attr.data-testid]="'blackout-rule-' + i + '-clear-dates'"
            >Clear dates</button>
            <button
              type="button"
              class="button is-small is-text"
              [disabled]="disabled"
              *ngIf="!hasDateValues(range)"
              (click)="hideDateSection(i)"
              [attr.data-testid]="'blackout-rule-' + i + '-hide-dates'"
            >Hide dates</button>
          </div>
        </ng-container>

        <ng-template #datesCollapsed>
          <button
            type="button"
            class="button is-small is-light"
            [disabled]="disabled"
            (click)="openDateSection(i)"
            [attr.data-testid]="'blackout-rule-' + i + '-show-dates'"
          >+ Limit to specific dates</button>
          <p class="blackout-hint">Repeats every week on the days selected above.</p>
        </ng-template>
      </div>

      <div class="blackout-field">
        <label class="label is-small" [id]="'blackout-rule-' + i + '-hours-label'">Hours</label>

        <p class="blackout-hint" *ngIf="isAllowAllDay(range)">
          Scoring is available all day on the selected date(s). Remove this rule to change that.
        </p>

        <div class="blackout-time-row" *ngIf="!isAllowAllDay(range)" role="group" [attr.aria-labelledby]="'blackout-rule-' + i + '-hours-label'">
          <div class="blackout-time-field">
            <span class="blackout-sub-label">From</span>
            <blackout-time-dropdown
              [value]="range.time_start"
              [disabled]="disabled"
              [testIdPrefix]="'blackout-rule-' + i + '-time-start'"
            ariaLabel="From"
              (valueChange)="onTimeChange(range, 'time_start', $event)"
            ></blackout-time-dropdown>
          </div>

          <div class="blackout-time-field">
            <span class="blackout-sub-label">Until</span>
            <blackout-time-dropdown
              [value]="range.time_end"
              [disabled]="disabled"
              [testIdPrefix]="'blackout-rule-' + i + '-time-end'"
            ariaLabel="Until"
              (valueChange)="onTimeChange(range, 'time_end', $event)"
            ></blackout-time-dropdown>
          </div>
        </div>

        <p class="blackout-hint" *ngIf="!isAllowAllDay(range)">
          Times use 24-hour clock in 15-minute steps.
          An end time earlier than the start time runs overnight and belongs to the day it started on.
        </p>
      </div>

      <div class="blackout-field">
        <label class="label is-small" [id]="'blackout-rule-' + i + '-applies-label'">Applies to</label>
        <div class="blackout-tasks" role="group" [attr.aria-labelledby]="'blackout-rule-' + i + '-applies-label'">
          <label class="checkbox" *ngFor="let task of markingTaskOptions">
            <input
              type="checkbox"
              [disabled]="disabled"
              [checked]="isTaskChecked(range, task.id)"
              (change)="toggleTask(range, task.id)"
              [attr.data-testid]="'blackout-rule-' + i + '-task-' + task.id"
            />
            {{ task.caption }}
          </label>
        </div>
        <p class="blackout-hint">
          Task types left unchecked stay available during this rule.
        </p>
      </div>

      <div class="buttons are-small blackout-rule-footer">
        <button
          type="button"
          class="button is-small is-danger is-outlined"
          [disabled]="disabled"
          (click)="removeRule(i)"
          [attr.data-testid]="'blackout-rule-remove-footer-' + i"
        >Remove this rule</button>
      </div>

    </div>

    <p
      role="alert"
      class="blackout-error"
      *ngIf="isExpanded(i) && validateRange(range)"
      [attr.data-testid]="'blackout-rule-error-' + i"
    >
      {{ validateRange(range) }}
    </p>
  </div>

  <div class="buttons are-small blackout-add-row">
    <button
      class="button is-small is-link is-light"
      [disabled]="disabled"
      (click)="addRecurringRule()"
      data-testid="blackout-add-recurring"
    >+ Weekly rule</button>
    <button
      class="button is-small is-link is-light"
      [disabled]="disabled"
      (click)="addDateRule()"
      data-testid="blackout-add-date"
    >+ Specific date</button>
  </div>

</div>
